import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/services/api-service/api.service';
import { APIEndpoints } from '@core/config/apiendpoint';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RequestService {

  constructor(private http: HttpClient, private apiService: ApiService) { }

  getSuperVisorData(requestParam: any) {
    return this.apiService.get(APIEndpoints.getSuperVisorList, requestParam).pipe(map((res) => res));
  }

  getDepartmentData(requestParam: any) {
    return this.apiService.get(APIEndpoints.getDepartmentData, requestParam).pipe(map((res) => res));
  }

  getProgramData(requestParam: any) {
    return this.apiService.get(APIEndpoints.getProgramList, requestParam).pipe(map((res) => res));
  }

  saveDraft(data: any, requestParam: any) {
    return this.apiService.post(APIEndpoints.saveDraft, data, requestParam).pipe(map((res) => res));
  }

  getDraftList(data: any, requestParam: any) {
    return this.apiService.post(APIEndpoints.getDraftList, data, requestParam).pipe(map((res) => res));
  }

  getDraftDetails(data: any, requestParam: any) {
    return this.apiService.post(APIEndpoints.getDraftDetails, data, requestParam).pipe(map((res) => res));
  }

  getPendingApprovalList(requestParam: any) {
    return this.apiService.get(APIEndpoints.getPendingApprovalList, requestParam).pipe(map((res) => res));
  }
  getSubmittedList(requestParam: any) {
    return this.apiService.get(APIEndpoints.getSubmittedList, requestParam).pipe(map((res) => res));
  }
  getProcessedList(requestParam: any) {
    return this.apiService.get(APIEndpoints.getProcessedList, requestParam).pipe(map((res) => res));
  }
  getReturnedList(requestParam: any) {
    return this.apiService.get(APIEndpoints.getReturnedList, requestParam).pipe(map((res) => res));
  }

  getFilterSearchList(requestParam: any) {
    return this.apiService.get(APIEndpoints.getFilterSearchList, requestParam).pipe(map((res) => res));
  }

  getPendingApprovalDetails(requestParam: any) {
    return this.apiService.get(APIEndpoints.getRequestDetailsData, requestParam).pipe(map((res) => res));
  }

  getDraftFilterList(data: any, requestParam: any) {
    return this.apiService.post(APIEndpoints.getDraftFilterData, data, requestParam).pipe(map((res) => res));
  }

  getSystemAccessHistory(requestParam: any) {
    return this.apiService.get(APIEndpoints.getSystemAccessHistory, requestParam).pipe(map((res) => res));
  }

  getManagerHistory(requestParam: any) {
    return this.apiService.get(APIEndpoints.getManagerUpdateHistory, requestParam).pipe(map((res) => res));
  }

  getProgramHistory(requestParam: any) {
    return this.apiService.get(APIEndpoints.getProgramUpdateHistory, requestParam).pipe(map((res) => res));
  }

  getJobTitleHistory(requestParam: any) {
    return this.apiService.get(APIEndpoints.getJobTitleUpdateHistory, requestParam).pipe(map((res) => res));
  }

  getAccessEndHistory(requestParam: any) {
    return this.apiService.get(APIEndpoints.getAccessEndUpdateHistory, requestParam).pipe(map((res) => res));
  }

  getContactUpdateHistory(requestParam: any) {
    return this.apiService.get(APIEndpoints.getContactUpdateHistory, requestParam).pipe(map((res) => res));
  }

  submitNonEmployeeRequest(data: any, requestParam: any) {
    return this.apiService.post(APIEndpoints.submitNonEmployeeRequest, data, requestParam).pipe(map((res) => res));
  }
  submitNonEmployeeRequestAutoApproval(data: any, requestParam: any) {
    return this.apiService.post(APIEndpoints.submitNonEmployeeRequestAutoApproval, data, requestParam).pipe(map((res) => res));
  }
}
